import { ReactElement } from 'react';

import { useAppSelector } from 'app/hooks';

import LOGO from './logo.svg';

import styles from './EmptyTour.module.scss';

const APP_STORE_BADGE =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/3840px-Download_on_the_App_Store_Badge.svg.png';

const APP_STORE_URL = 'https://apps.apple.com/us/app/the3dapp/id1599161455';

function EmptyTour(): ReactElement {
  const { user } = useAppSelector((state) => state.authState);
  const name = user?.name ?? user?.email;

  return (
    <div className={styles.container}>
      <h1>{name ? `Welcome, ${name}!` : 'Welcome!'}</h1>
      <img className={styles.logo} src={LOGO} alt="The 3D App logo" />
      <p>Install The3Dapp to start capturing tours.</p>
      <a
        className={styles.appStoreLink}
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.appStoreBadge}
          src={APP_STORE_BADGE}
          alt="Download on the App Store"
        />
      </a>
    </div>
  );
}

export default EmptyTour;
